import React from 'react';
import { makeStyles, Paper, Grid } from '@material-ui/core';

import PageTitle from '../components/PageTitle/PageTitle';

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  paper: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(4),
    maxWidth: 700,
  },
  btnLink: {
    textDecoration: 'none',
  },
}));

function Dashboard() {
  const classes = useStyles();

  return (
    <>
      <div className={classes.titleContainer}>
        <PageTitle title="Dashboard" />
      </div>
      <Paper elevation={0} className={classes.paper}>
        <Grid item container spacing={2} justify="center"></Grid>
      </Paper>
    </>
  );
}

export default Dashboard;
